/** Синтетический email аккаунтов «только телефон» — подтверждение почты не требуется. */
export function isSyntheticPhoneEmail(email: string | undefined): boolean {
  return !!email && email.endsWith('@internal.qwartet.local');
}

/**
 * Нужно ли блокировать ЛК до подтверждения email (парольная регистрация и т.п.).
 * OAuth с подтверждённым email приходит с emailVerified с бэкенда.
 */
export function needsEmailVerificationFromUser(user: unknown): boolean {
  if (!user || typeof user !== 'object') return false;
  const o = user as Record<string, unknown>;
  const email = o.email;
  if (typeof email !== 'string') return false;
  if (isSyntheticPhoneEmail(email)) return false;
  const v = o.emailVerified ?? o.email_verified;
  if (v === true) return false;
  return true;
}

export function needsEmailVerificationFromProfile(profile: {
  email?: string;
  emailVerified?: boolean;
  email_verified?: boolean;
}): boolean {
  const email = profile.email;
  if (typeof email !== 'string') return false;
  if (isSyntheticPhoneEmail(email)) return false;
  const v = profile.emailVerified ?? profile.email_verified;
  if (v === true) return false;
  return true;
}
